module.exports = __webpack_public_path__ + "static/media/iconUser.ac3caeed.png";